import styled from 'styled-components'

import { barrierWidth } from '../../../../../../../utils/constants'

export const TextContainer = styled.p`
    display: -webkit-box;
    width: ${barrierWidth - 16}px;
    line-height: 12px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 9px;
    color: ${({ theme }) => theme['gray-1000']};
    margin: 0;
`
